import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EmployeesListComponent } from './employees-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { EmployeesListService } from './employees-list.service';

@Component({
    selector: 'app-employees-dialog-delete',
    templateUrl: './employees-dialog-delete.component.html',
    styleUrls: ['./employees-dialog-delete.component.css'],
    standalone: false
})
export class EmployeesDialogDeleteComponent {
  uid: number = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  constructor(
    public employeesService: EmployeesListService,
    public dialogRef: MatDialogRef<EmployeesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  delete() {
    this.employeesService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
